export default {
  title: 'Nueva Segmentación',
  title_edit: 'Editando Segmentación',

  bulkEdit: 'Registro masivo',
  'bulkEdit.fields.checklistTypes': 'Tipos de cuestionario',
  'bulkEdit.fields.userGroups': 'Grupos de usuario',
  'bulkEdit.fields.placeLevels': 'Niveles de local',
  'bulkEdit.fields.assets': 'Activos',

  'generalStep.title': 'Información Básica',
  'generalStep.subtitle': 'Complete la información de la segmentación',
  'generalStep.name': 'Nombre*',
  'generalStep.nameRequired': 'Por favor agregue un nombre',

  'checklistTypes.title': 'Tipos de cuestionario',
  'checklistTypes.subtitle': 'Seleccione los tipos de cuestionario a los que esta segmentación está asociada',
  'checklistTypes.selectTypeRequired': 'Seleccione un tipo de cuestionario',

  'groupStep.title': 'Grupos de usuario',
  'groupStep.subtitle': 'Seleccione los grupos de usuario que ejecutarán esta actividad',
  'groupStep.selectGroupRequired': 'Seleccione un grupo',

  'placeLevelStep.title': 'Locales/Personas',
  'placeLevelStep.subtitle': 'Seleccione los locales/personas que serán usados en esta actividad',
  'placeLevelStep.selectPlaceRequired': 'Seleccione un local/persona',

  'assetStep.title': 'Activos',
  'assetStep.subtitle': 'Seleccione los activos que serán usados en esta actividad',
  'assetStep.validation.selectAsset': 'Seleccione al menos un activo',

  'resumeStep.title': 'Resumen',
  'resumeStep.subtitle': 'Revise los datos',

  all: 'Todos',
  ignoring: 'Ignorando'
}
